import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {pluralize} from 'BenchlingUtil';
import {DATA_FRAMES_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {DataFrame} from 'data-frames/DataFrameTypes';
import {DataFrameTableMode} from 'data-frames/table/DataFrameTableConstants';
import makeDataFrameExportString from 'data-frames/util/makeDataFrameExportString';
import Option from 'ui-library/menus/Option';
import copyToClipboard from 'util/clipboard/copyToClipboard';

import {OverflowActionRenderFn, ToolbarActionRenderParams} from '../DataFrameActionToolbar';

function copyDataFrameToClipboard(dataFrame: DataFrame, selectedRowIds: Set<string>): void {
  // Download as TEXT to be consistent with downloads, and avoid a dependency on hydrated properties.
  copyToClipboard(makeDataFrameExportString(dataFrame, selectedRowIds, DataFrameTableMode.TEXT, '\t'), {
    showToastOnSuccess: true,
    toastText:
      selectedRowIds.size === 0
        ? 'Copied table to clipboard.'
        : `Copied ${selectedRowIds.size} ${pluralize(selectedRowIds.size, 'row')} to clipboard.`,
  });
}

export const renderCopyToClipboardOption: OverflowActionRenderFn = (
  dataFrame: DataFrame,
  params: Pick<ToolbarActionRenderParams, 'dataFrameId' | 'selectedRowIds' | 'actionOrigin'>
) => {
  const numSelectedRows = params.selectedRowIds.size;
  return (
    <Option
      icon="copy"
      key="CopyToClipboardOption"
      onSelect={() => {
        copyDataFrameToClipboard(dataFrame, params.selectedRowIds);
        trackEvent(DATA_FRAMES_ANALYTICS_ACTIONS.EXPORTED_DATA_FRAME, {
          data_frame_id: params.dataFrameId,
          action_origin: params.actionOrigin,
          type: 'clipboard',
          num_rows_selected: params.selectedRowIds.size,
          total_columns: dataFrame.columns.length,
          total_rows: dataFrame.rows.length,
        });
      }}
    >
      {numSelectedRows === 0
        ? 'Copy to clipboard'
        : `Copy ${numSelectedRows} ${pluralize(numSelectedRows, 'row')} to clipboard`}
    </Option>
  );
};
